import { Microfrontend } from '@thoughtspot/microfrontends';
import React from 'react';
import { loadMicroFrontendComponent } from './microfrontend-wrapper';

enum EmbedDevPortalComponents {
    EverywherePage = 'EverywherePage',
    StyleCustomizationAdmin = 'StyleCustomizationAdmin',
    NavPanel = 'NavPanel',
}

export const EverywherePage = loadMicroFrontendComponent(
    Microfrontend.EMBED_DEV_PORTAL,
    EmbedDevPortalComponents.EverywherePage,
);

export const StyleCustomizationAdmin = loadMicroFrontendComponent(
    Microfrontend.EMBED_DEV_PORTAL,
    EmbedDevPortalComponents.StyleCustomizationAdmin,
);

export const NavPanel = loadMicroFrontendComponent(
    Microfrontend.EMBED_DEV_PORTAL,
    EmbedDevPortalComponents.NavPanel,
);
